import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILocumJobs } from '../../models/dashboard/jobs/getLocumJobs.model';

interface IInvitedSingleJobQuery {
  jobId?: string;
  jobData?: ILocumJobs;
}

const initialState: IInvitedSingleJobQuery = {
  jobId: undefined,
  jobData: undefined,
};

const invitedSingleJobSlice = createSlice({
  name: 'invitedSingleJob',
  initialState,
  reducers: {
    getInvitedSingleJob(state, action: PayloadAction<IInvitedSingleJobQuery>) {
      state.jobId = action.payload.jobId;
      state.jobData = action.payload.jobData;
    },
    clearInvitedSingleJob(state) {
      state.jobId = undefined;
      state.jobData = undefined;
    },
  },
});

export const invitedSingleJobsActions = invitedSingleJobSlice.actions;
export default invitedSingleJobSlice.reducer;
